import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"
import { abs, min } from "../../core/util/math/Math"
import setMapControlsPolarAngle from "../fn/setMapControlsPolarAngle"

export function tweenPolarAngleTo(
  controls: OrbitControls,
  targetAngle: number,
  duration: number,
  epsilon = 0.0001
): Promise<void> {
  const start = performance.now()
  const initialAngle = controls.getPolarAngle()
  const delta = targetAngle - initialAngle

  return new Promise((resolve) => {
    function animate(now: number) {
      const elapsed = now - start
      const progress = min(elapsed / duration, 1)

      const currentAngle = initialAngle + delta * progress
      setMapControlsPolarAngle(controls, currentAngle)
      controls.update()

      if (progress < 1 && abs(currentAngle - targetAngle) > epsilon) {
        requestAnimationFrame(animate)
      } else {
        setMapControlsPolarAngle(controls, targetAngle) // snap to final
        controls.update()
        resolve()
      }
    }

    requestAnimationFrame(animate)
  })
}
